import { createReducer, on } from '@ngrx/store';

import { GroupPickId } from '../../../core/picks/pick-id';
import BetslipPickActions from '../../picks/actions';
import BetslipErrorsActions from '../../validation/actions';
import { getErrorsAcrossTypesForPicks } from '../../validation/services/utils/betslip-errors-state-utils';
import AffiliateActions from './affiliate.actions';
import { defaultAffiliateState } from './affiliate.state';

export const affiliateReducer = createReducer(
    defaultAffiliateState,
    on(BetslipPickActions.addAffiliatePicks, (state, action) => {
        return {
            ...state,
            optionRequest: action.request,
        };
    }),
    on(AffiliateActions.setAffiliateLink, (state, action) => {
        const affiliateLink = action.link;

        return {
            ...state,
            affiliateLink,
        };
    }),
    on(AffiliateActions.resetAffiliateState, (state, action) => {
        return defaultAffiliateState;
    }),
    on(AffiliateActions.addAffiliatePick, (state, action) => {
        const pickId = action.payload.pickId.toString();

        return {
            ...state,
            pendingPicks: [...state.pendingPicks, pickId],
        };
    }),
    on(AffiliateActions.addAffiliateBetBuilderPick, (state, action) => {
        const pickId = action.pickId.toString();

        return {
            ...state,
            pendingPicks: [...state.pendingPicks, pickId],
        };
    }),
    on(AffiliateActions.addAffiliateGroupPick, (state, action) => {
        const picks = action.picks
            .filter((p) => !!p.groupInfo)
            .map((p) => new GroupPickId(p.groupInfo!).toString())
            .filter((p, index, arr) => arr.indexOf(p) === index);

        return {
            ...state,
            pendingPicks: [...state.pendingPicks, ...picks],
        };
    }),
    on(BetslipErrorsActions.picksErrorsCheckFinished, (state, action) => {
        const pickErrors = getErrorsAcrossTypesForPicks(action.errors);

        if (!state.pendingPicks.length || !state.pendingPicks.some((p) => pickErrors[p])) {
            return state;
        }

        const added = [...state.addedPicks];
        const failed = [...state.failedPicks];
        let pending = [...state.pendingPicks];

        state.pendingPicks.forEach((pick) => {
            if (pickErrors[pick]) {
                if (pickErrors[pick].length) {
                    failed.push(pick);
                } else {
                    added.push(pick);
                }
                pending = pending.filter((pickId) => pickId !== pick);
            }
        });

        return {
            ...state,
            pendingPicks: pending,
            addedPicks: added,
            failedPicks: failed,
        };
    }),
    on(AffiliateActions.openBetslip, (state, action) => {
        return {
            ...state,
            openedBetslip: true,
        };
    }),
);
